var histories = [];
var History = {
	"p": "",
	"u": "",
	"i": ""
}
var hstry = {
	visited: 0,
	before: "",
	init: function(){
		hstry.before = "";
		hstry.visited = localStorage.getItem("stayplus_visited");
		/*
			初回に限らずSPOTに行ってないと配列が生成されてないので、チェックして作成する
		*/
		if(hstry.visited === "1"){
			//stayplusに訪問済み
			if( localStorage.getItem('stayplus') ){
				hstry.load();
			}else{
				histories = [];
				hstry.save();
			}
		}else{
			histories = [];
			localStorage.setItem("stayplus_visited", 1);
			
			hstry.save();
		}
	},
	changeBeforeHistory: function(){
		//1つ前のページを覚えておく
		if(loadPage.isLoadMore){

		}else{
			hstry.before = location.pathname;
		}
		//console.log("1つ前のページ：", hstry.before);
	},
	add: function(){
		hstry.load();
		let thisPage = location.pathname;
		let urlArry = thisPage.split("/");
		//console.log(urlArry)
		if(urlArry.length > 4 && urlArry[urlArry.length-2] === "spot"){
		//	console.log("add to history", thisPage);
			let _h = object(History);
			_h.p = page.folder;
			_h.u = thisPage;
			_h.i = $("#spot .img_main figure").attr("data-img");
			histories.push(_h);
			histories = _.uniq(histories, 'u');
			hstry.save();
		}
		
	},
	save: function(){
		let historyArry = JSON.stringify( histories );
		localStorage.setItem("stayplus", historyArry );
	},
	load: function(){
		let ls = localStorage.getItem('stayplus');
		let historyArry = JSON.parse( ls );
		histories = _.uniq(historyArry, 'u');
		histories = _.filter(histories, function(item){
			return item.p === "spot"
		});
		let historyHTML = '';
		let count = 0;
		for(var i = 0; i < histories.length; i++){
			if(histories[i].u != location.pathname){
				historyHTML += '<li>'
							+ '<a class="link_history" href="' + histories[i].u + '" title="">'
							+ '<figure style="background-image: url(' + histories[i].i + ')"></figure>'
							+ '</a>'
							+ '</li>';
				count++;
			}
		}
		if(count === 0){
			$(".history").addClass("disable");
		}else{
			$(".history .list_spots").html(historyHTML);
			common.nav();
		}
	}
}